import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Box } from '@material-ui/core';


import 'primeflex/primeflex.css';
import '../../css/nlu.css';

const Nlu = ({ setForm, formData }) => {

    const onInputChange = (e, name) => {
        const val = (e.target.type === 'checkbox') ? (e.checked) : e.target.value;
        let _localForm = { ...formData };
        _localForm[`${name}`] = val;

        setForm(_localForm);
    }

    return (
        <div className="nlu">

            <Box>
                <div className="p-fluid p-grid">
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="project">Projeto DIALOGFLOW</label>
                        <InputText id="project" value={formData.dialogflowProject} onChange={(e) => onInputChange(e, 'dialogflowProject')} required autoFocus />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="credentials">Credenciais do Projeto</label>
                        <InputText id="credentials" value={formData.dialogflowCredentialsURL} onChange={(e) => onInputChange(e, 'dialogflowCredentialsURL')} required />
                    </div>

                    <div className="p-field p-col-12 p-md-12"><h3>Funcionalidades</h3></div>

                    <div className="p-field-checkbox p-col-12 p-md-12">
                        <Checkbox inputId="sentimentAnalysis" onChange={(e) => onInputChange(e, 'sentimentAnalysis')} checked={formData.sentimentAnalysis} />
                        <label htmlFor="sentimentAnalysis">Sentiment Analysis</label>
                    </div>
                    <div className="p-field-checkbox p-col-12 p-md-12">
                        <Checkbox inputId="fullfilment" onChange={(e) => onInputChange(e, 'fullfilment')} checked={formData.fullfilment} />
                        <label htmlFor="fullfilment">Fullfilment</label>
                    </div>
                    <div className="p-field-checkbox p-col-12 p-md-12">
                        <Checkbox inputId="slotFilling" onChange={(e) => onInputChange(e, 'slotFilling')} checked={formData.slotFilling} />
                        <label htmlFor="slotFilling">Slot Filling</label>
                    </div>
                    <div className="p-field-checkbox p-col-12 p-md-12">
                        <Checkbox inputId="kbAutoconverter" onChange={(e) => onInputChange(e, 'kbAutoconverter')} checked={formData.kbAutoconverter} />
                        <label htmlFor="kbAutoconverter">Kb Autoconverter</label>
                    </div>
                    <div className="p-field-checkbox p-col-12 p-md-12">
                        <Checkbox inputId="flowValidation" onChange={(e) => onInputChange(e, 'flowValidation')} checked={formData.flowValidation} />
                        <label htmlFor="flowValidation">Flow Validation</label>
                    </div>
                    <div className="p-field-checkbox p-col-12 p-md-12">
                        <Checkbox inputId="smartEntities" onChange={(e) => onInputChange(e, 'smartEntities')} checked={formData.smartEntities} />
                        <label htmlFor="smartEntities">SmartEntities</label>
                    </div>

                </div>
            </Box>
        </div>
    );
}
export default Nlu;